<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="modal-cobranca rounded-lg shadow-xl max-w-5xl w-full max-h-[90vh] overflow-y-auto" style="background-color: var(--bg-secondary)">
      <!-- Header -->
      <div class="modal-cobranca-header sticky top-0 z-10 px-6 py-4 border-b" style="background-color: var(--bg-secondary); border-color: var(--border)">
        <h2 class="text-2xl font-bold" style="color: var(--text-primary)">
          {{ cobranca ? `✏️ ${t('financeiro.modalCobranca.editTitle')}` : `💵 ${t('financeiro.modalCobranca.newTitle')}` }}
        </h2>
      </div>

      <!-- Body -->
      <div class="modal-cobranca-body p-6">
        <div class="modal-cobranca-content">
          <div class="modal-cobranca-form space-y-6">
        <!-- Cliente -->
        <div>
          <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">
            {{ t('financeiro.modalCobranca.client') }} * 
            <span v-if="clientePreSelecionado" class="ml-2 px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800">✓ {{ t('financeiro.modalCobranca.preSelected') }}</span>
          </label>
          <select v-model="form.clienteId" required class="input-field w-full" :disabled="!!cobranca || !!clientePreSelecionado">
            <option value="">{{ t('financeiro.modalCobranca.selectClient') }}</option>
            <option v-for="cliente in clientes" :key="cliente.id" :value="cliente.id">
              {{ cliente.nome }}
            </option>
          </select>
        </div>

        <!-- Descrição -->
        <div>
          <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCobranca.description') }} *</label>
          <input v-model="form.descricao" type="text" required class="input-field w-full" />
        </div>

        <!-- Tipo de Serviço -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCobranca.serviceType') }} *</label>
            <select v-model="form.tipoServico" required class="input-field w-full">
              <option value="MONKEY">🐵 {{ t('financeiro.modalCobranca.serviceMonkey') }}</option>
              <option value="ONEWAY">🚀 {{ t('financeiro.modalCobranca.serviceOneway') }}</option>
              <option value="OUTRO">📦 {{ t('financeiro.modalCobranca.serviceOther') }}</option>
            </select>
          </div>

          <div>
            <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCobranca.contractType') }} *</label>
            <select v-model="form.tipoContrato" required class="input-field w-full" @change="alterarTipoContrato">
              <option value="MENSAL">📅 {{ t('financeiro.modalCobranca.contractMonthly') }}</option>
              <option value="TOTAL">💰 {{ t('financeiro.modalCobranca.contractTotal') }}</option>
            </select>
          </div>
        </div>

        <!-- Valores + Datas -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div v-if="form.tipoContrato === 'MENSAL'">
            <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCobranca.monthlyValue') }} *</label>
            <input v-model.number="form.valorMensal" type="number" step="0.01" required class="input-field w-full" />
          </div>

          <div v-if="form.tipoContrato === 'TOTAL'">
            <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCobranca.totalValue') }} *</label>
            <input v-model.number="form.valorTotal" type="number" step="0.01" required class="input-field w-full" />
          </div>

          <div v-if="form.tipoContrato === 'TOTAL'">
            <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCobranca.installmentsCount') }} *</label>
            <input v-model.number="form.numeroPrestacoes" type="number" min="1" required class="input-field w-full" />
          </div>

          <div>
            <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCobranca.dueDay') }} *</label>
            <input v-model.number="form.diaVencimento" type="number" min="1" max="31" required class="input-field w-full" :placeholder="t('financeiro.modalCobranca.dueDayPlaceholder')" />
          </div>

          <div>
            <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCobranca.startDate') }}</label>
            <input v-model="form.dataInicio" type="date" class="input-field w-full" />
          </div>

          <div v-if="form.tipoContrato === 'MENSAL'">
            <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCobranca.contractMonthsQty') }}</label>
            <input v-model.number="form.qtdMesesContrato" type="number" min="1" class="input-field w-full" />
          </div>
        </div>

        <!-- Observação -->
        <div>
          <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCobranca.observation') }}</label>
          <textarea v-model="form.observacao" rows="3" class="input-field w-full"></textarea>
        </div>

        <!-- Info Box -->
        <div class="p-4 rounded-lg" style="background-color: var(--bg-primary); border: 1px solid var(--border)">
          <p class="text-sm font-medium mb-2" style="color: var(--text-primary)">ℹ️ {{ t('financeiro.modalCobranca.infoTitle') }}</p>
          <ul class="text-sm space-y-1" style="color: var(--text-secondary)">
            <li>• {{ t('financeiro.modalCobranca.infoBoletoAuto') }}</li>
            <li v-if="form.tipoContrato === 'MENSAL'">• {{ t('financeiro.modalCobranca.infoMonthly') }}</li>
            <li v-if="form.tipoContrato === 'TOTAL'">• {{ t('financeiro.modalCobranca.infoInstallments') }}</li>
          </ul>
        </div>
          </div>

          <!-- Preview de parcelas -->
          <aside class="modal-cobranca-preview">
            <div class="preview-card">
              <div class="preview-header">
                <div class="preview-title">
                  <span class="preview-icon">🧾</span>
                  <div>
                    <p class="preview-title-text">{{ t('financeiro.modalCobranca.installmentsSummary') }}</p>
                    <p class="preview-subtitle">{{ t('financeiro.modalCobranca.installmentsPreview') }}</p>
                  </div>
                </div>
                <span class="preview-count">{{ previewParcelas.length }}</span>
              </div>

              <div v-if="previewParcelas.length === 0" class="preview-empty">
                <div class="preview-empty-icon">📅</div>
                <p>{{ t('financeiro.modalCobranca.fillFieldsPreview') }}</p>
              </div>

              <div v-else class="preview-list">
                <div v-for="(parcela, index) in previewParcelas" :key="index" class="preview-item">
                  <div class="preview-date">
                    <span class="preview-date-icon">📆</span>
                    <span>{{ parcela.data }}</span>
                  </div>
                  <div class="preview-valor"><MoneyAmount :value="parcela.valorNum" size="sm" /></div>
                  <div class="preview-label">{{ parcela.label }}</div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-cobranca-footer sticky bottom-0 px-6 py-4 border-t flex justify-end gap-3" style="background-color: var(--bg-secondary); border-color: var(--border)">
        <button @click="fechar" class="btn-secondary">{{ t('common.cancel') }}</button>
        <button @click="salvar" class="btn-primary">{{ cobranca ? t('common.update') : t('common.create') }}</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import api from '../../services/api'
import Swal from 'sweetalert2'
import MoneyAmount from '../MoneyAmount.vue'

const { t } = useI18n()

const props = defineProps({
  cobranca: Object,
  clientePreSelecionado: Object
})

const emit = defineEmits(['fechar', 'salvar'])

const clientes = ref([])

const form = ref({
  clienteId: null,
  descricao: '',
  observacao: '',
  tipoServico: 'MONKEY',
  tipoContrato: 'MENSAL',
  valorTotal: 0,
  valorMensal: 0,
  numeroPrestacoes: 1,
  qtdMesesContrato: 12,
  diaVencimento: 10,
  dataInicio: new Date().toISOString().split('T')[0],
  dataFim: null
})

const formatDateInput = (date) => date.toISOString().split('T')[0]
const formatDatePreview = (date) => {
  return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(date)
}
const addMonths = (date, months, day) => {
  const d = new Date(date)
  d.setMonth(d.getMonth() + months)
  if (day) {
    d.setDate(day)
  }
  return d
}

const diffInMonths = (startDate, endDate) => {
  if (!startDate || !endDate) return null
  const start = new Date(startDate)
  const end = new Date(endDate)
  return (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth()) + 1
}

const previewParcelas = computed(() => {
  const tipoContrato = form.value.tipoContrato
  const diaVencimento = Number(form.value.diaVencimento) || null
  const dataInicio = form.value.dataInicio ? new Date(form.value.dataInicio) : new Date()

  if (!diaVencimento || !tipoContrato) {
    return []
  }

  const parcelas = []

  if (tipoContrato === 'TOTAL') {
    const total = Number(form.value.valorTotal || 0)
    const numero = Number(form.value.numeroPrestacoes || 0)
    if (!numero || numero < 1) return []
    const valorParcela = total / numero

    for (let i = 0; i < numero; i += 1) {
      const data = addMonths(dataInicio, i, diaVencimento)
      parcelas.push({
        data: formatDatePreview(data),
        valorNum: valorParcela,
        label: t('financeiro.modalCobranca.installmentLabel', { n: i + 1 })
      })
    }
  } else {
    const valorMensal = Number(form.value.valorMensal || 0)
    const qtdMeses = Number(form.value.qtdMesesContrato || 0)
    if (!qtdMeses || qtdMeses < 1) return []

    let i = 0
    let data = addMonths(dataInicio, 0, diaVencimento)
    while (i < qtdMeses) {
      parcelas.push({
        data: formatDatePreview(data),
        valorNum: valorMensal,
        label: t('financeiro.modalCobranca.installmentLabel', { n: i + 1 })
      })
      i += 1
      data = addMonths(dataInicio, i, diaVencimento)
    }
  }

  return parcelas
})

onMounted(async () => {
  window.addEventListener('keydown', handleEsc)
  await carregarClientes()
  
  if (props.cobranca) {
    form.value = {
      clienteId: props.cobranca.clienteId,
      descricao: props.cobranca.descricao,
      observacao: props.cobranca.observacao,
      tipoServico: props.cobranca.tipoServico,
      tipoContrato: props.cobranca.tipoContrato,
      valorTotal: props.cobranca.valorTotal,
      valorMensal: props.cobranca.valorMensal,
      numeroPrestacoes: props.cobranca.numeroPrestacoes,
      diaVencimento: props.cobranca.diaVencimento,
      dataInicio: props.cobranca.dataInicio,
      dataFim: props.cobranca.dataFim,
      qtdMesesContrato: diffInMonths(props.cobranca.dataInicio, props.cobranca.dataFim) || 12
    }
  } else if (props.clientePreSelecionado) {
    // Se tem cliente pré-selecionado, preenche o formulário
    form.value.clienteId = props.clientePreSelecionado.id
  }
})

onUnmounted(() => {
  window.removeEventListener('keydown', handleEsc)
})

async function carregarClientes() {
  try {
    const response = await api.get('/financeiro/clientes')
    clientes.value = response.data
  } catch (error) {
    console.error('Erro ao carregar clientes:', error)
    Swal.fire('Erro', t('financeiro.modalCobranca.loadClientsError'), 'error')
  }
}

function alterarTipoContrato() {
  if (form.value.tipoContrato === 'MENSAL') {
    form.value.valorTotal = form.value.valorMensal * 12
  } else {
    form.value.valorMensal = 0
  }
}

function fechar() {
  emit('fechar')
}

function handleEsc(event) {
  if (event.key === 'Escape') {
    fechar()
  }
}

function salvar() {
  console.log('🔍 Validando formulário:', form.value)
  
  if (!form.value.clienteId) {
    Swal.fire('Atenção', t('financeiro.modalCobranca.selectClientRequired'), 'warning')
    return
  }
  
  if (!form.value.descricao) {
    Swal.fire('Atenção', t('financeiro.modalCobranca.descriptionRequired'), 'warning')
    return
  }

  if (form.value.tipoContrato === 'MENSAL' && (!form.value.valorMensal || form.value.valorMensal <= 0)) {
    Swal.fire('Atenção', t('financeiro.modalCobranca.monthlyValueRequired'), 'warning')
    return
  }

  if (form.value.tipoContrato === 'MENSAL' && (!form.value.qtdMesesContrato || form.value.qtdMesesContrato <= 0)) {
    Swal.fire('Atenção', t('financeiro.modalCobranca.monthsQtyRequired'), 'warning')
    return
  }

  if (form.value.tipoContrato === 'TOTAL' && (!form.value.valorTotal || form.value.valorTotal <= 0 || !form.value.numeroPrestacoes || form.value.numeroPrestacoes <= 0)) {
    Swal.fire('Atenção', t('financeiro.modalCobranca.totalInstallmentsRequired'), 'warning')
    return
  }

  if (!form.value.diaVencimento || form.value.diaVencimento < 1 || form.value.diaVencimento > 31) {
    Swal.fire('Atenção', t('financeiro.modalCobranca.dueDayInvalid'), 'warning')
    return
  }

  // Calcular o valor total baseado no tipo de contrato
  if (form.value.tipoContrato === 'MENSAL') {
    form.value.valorTotal = form.value.valorMensal * form.value.qtdMesesContrato
    const dataBase = form.value.dataInicio ? new Date(form.value.dataInicio) : new Date()
    const dataFim = addMonths(dataBase, form.value.qtdMesesContrato - 1, form.value.diaVencimento)
    form.value.dataFim = formatDateInput(dataFim)
  }

  console.log('✅ Formulário válido, enviando:', form.value)
  emit('salvar', form.value)
}
</script>

<style scoped>
.modal-cobranca {
  border-radius: 16px;
}

.modal-cobranca-header {
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.modal-cobranca-body {
  background-color: var(--bg-secondary);
}

.modal-cobranca-footer {
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
}

.modal-cobranca-content {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(0, 0.65fr);
  gap: 1.5rem;
}

.modal-cobranca-preview {
  position: sticky;
  top: 90px;
  align-self: start;
}

.preview-card {
  background-color: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 1rem;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.1);
  max-height: calc(90vh - 200px);
  overflow-y: auto;
}

.preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--border);
  padding-bottom: 0.75rem;
  margin-bottom: 0.75rem;
}

.preview-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.preview-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(59, 130, 246, 0.15);
  font-size: 1.1rem;
}

.preview-title-text {
  font-weight: 600;
  color: var(--text-primary);
}

.preview-subtitle {
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.preview-count {
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  font-size: 0.75rem;
  background-color: var(--bg-secondary);
  color: var(--text-primary);
}

.preview-empty {
  text-align: center;
  padding: 1.5rem 0;
  color: var(--text-secondary);
  font-size: 0.85rem;
}

.preview-empty-icon {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.preview-list {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.preview-item {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 0.5rem;
  align-items: center;
  padding: 0.55rem 0.75rem;
  border-radius: 10px;
  background-color: var(--bg-secondary);
  border: 1px solid var(--border);
  font-size: 0.8rem;
}

.preview-date {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: var(--text-secondary);
}

.preview-date-icon {
  font-size: 0.9rem;
}

.preview-valor {
  font-weight: 600;
  color: var(--text-primary);
  text-align: right;
}

.preview-label {
  font-size: 0.75rem;
  color: var(--text-secondary);
  text-align: right;
}

@media (max-width: 1024px) {
  .modal-cobranca-content {
    grid-template-columns: 1fr;
  }
  .modal-cobranca-preview {
    position: static;
  }
}
.input-field {
  @apply px-3 py-2 rounded-lg border;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  border-color: var(--border);
}

.btn-primary {
  @apply px-6 py-2 rounded-lg font-medium transition-all bg-blue-600 text-white hover:bg-blue-700;
}

.btn-secondary {
  @apply px-6 py-2 rounded-lg font-medium transition-all;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  border: 1px solid var(--border);
}

.btn-secondary:hover {
  background-color: var(--bg-secondary);
}
</style>

